import { LOGIN as SOCKET_LOGIN } from '../../events/ClientToServer'
import { 
    LOG_OUT as SOCKET_LOG_OUT,
    DELETE_USER as SOCKET_DELETE_USER,
    START_PLAYING as SOCKET_START_PLAYING,
    STOP_PLAYING as SOCKET_STOP_PLAYING,
} from '../../events/ClientToServer'

export const LOGIN = 'LOGIN'
export const TEMPORARY_LOGIN = 'TEMPORARY_LOGIN'
export const LOGIN_RESULT = 'LOGIN_RESULT'
export const PASSWORD_RESET = 'PASSWORD_RESET'
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD'
export const PASSWORD_UPDATED = 'PASSWORD_UPDATED'
export const LOG_OUT = 'LOG_OUT'
export const START_PLAYING = 'START_PLAYING'
export const STOP_PLAYING = 'STOP_PLAYING'  
export const DELETE_USER = 'DELETE_USER'
export const USER_DELETED = 'USER_DELETED'
export const LOGGED_OUT = 'LOGGED_OUT'

export const login = (socket, username) => {
    socket.emit(SOCKET_LOGIN, { username })
    return { type: LOGIN, username}
}
export const loginResult = (user) => {
    return { type: LOGIN_RESULT, ...user }
}

export const logOut = (socket,{user}) => {
    socket.emit(SOCKET_LOG_OUT, { user })
    return { type: LOG_OUT, user }
}

export const startPlaying = (socket,{user_id}) => {
    socket.emit(SOCKET_START_PLAYING, { user_id })
    return { type: START_PLAYING, user_id }
}

export const stopPlaying = (socket,{user_id}) => {
    socket.emit(SOCKET_STOP_PLAYING, { user_id })
    return { type: STOP_PLAYING, user_id }
}


export const deleteUser = (socket,{user}) => {
    socket.emit(SOCKET_DELETE_USER,  user)
    return { type: DELETE_USER, user }
}

export const userDeleted = (user_id) => {
    window.location.reload();
    return {type: USER_DELETED, user_id}
}

export const loggedOut = (user) => {
    window.location.reload();
    return {type: LOGGED_OUT, user}
}



// WEBPACK FOOTER //
// ./src/reducers/user/actions.js